import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

import useGlobal from '../../../../store';
import RecepcionUploadForm from './components/RecepcionUploadForm';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';

const mapState = (store) => {
  const { recepcion } = store.modulo;

  return {
    upload: recepcion.upload,
    list: recepcion.list,
  };
};

const mapActions = (actions) => {
  const { recepcion } = actions.modulo;

  return {
    upload: recepcion.upload,
    list: recepcion.list,
  };
};

const RecepcionUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result } = state.upload;

  let errors = undefined;

  if (!!result) {
    const { data: recepcion } = result;

    if (recepcion[0].errors.length > 0) {
      errors = recepcion[0].errors;
    }
  }

  const isValid = !!data.tipo && !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (!busy) {
      props.history.replace('/modulos/recepcion');
    }
  };

  const upload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  useEffect(() => {
    if (!!result && state.list.pagination.page === 1) {
      actions.list.paginate({});
    }
  }, [result]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!!result && !errors) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleClose}
        />
      </div>
    );
  }

  if (!!errors) {
    const error = {
      errors,
    };

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={handleClose}
        />
      </div>
    );
  }

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={true}
        centered={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RecepcionUploadForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={busy || !isValid}
            onClick={upload}
          >
            Subir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RecepcionUpload;
